import m from "./ghl-ui.es1505.js";
import n from "./ghl-ui.es1506.js";
import u from "./ghl-ui.es1524.js";
import i from "./ghl-ui.es1466.js";
function h(t, o) {
  i(2, arguments);
  var r = n(t), e = m(o), a = Math.floor(r.getMonth() / 3) + 1, f = e - a;
  return u(r, r.getMonth() + f * 3);
}
export {
  h as default
};
